import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { ICONS } from '../../../../_helpers/icons.constants';
@Component({
    selector: 'download-renderer',
    templateUrl: './download-renderer.component.html',
    standalone: true,
    imports: [TranslateModule]
})
export class DownloadRendererComponent implements ICellRendererAngularComp {
    public csvURL: string;
    constructor() { }
    public ICONS = ICONS;
    agInit(params: ICellRendererParams): void {
        this.csvURL = params.value;
    }

    refresh(params: ICellRendererParams): boolean {
        this.csvURL = params.value;
        return true;
    }
    download() {
        window.open(this.csvURL, "_blank");
    }
}